import React from 'react';
import { connect } from "react-redux";
import { withRouter, matchPath } from 'react-router-dom';

import Sidenav from './Sidenav';

const mapStateToProps = (state, ownProps) => {

    const isPlayer = matchPath(ownProps.location.pathname, {
        path: '/stories/:storyId',
        exact: true
    });

    const isEditor = matchPath(ownProps.location.pathname, {
        path: '/stories/:storyId/edit',
        exact: true
    });

    return {
        user: state.auth,
        isEditor: isEditor,
        isPlayer: isPlayer
    }
};

export default withRouter(
    connect(mapStateToProps)(Sidenav)
);
